const ucfirst = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1)
);

export {
  // eslint-disable-next-line import/prefer-default-export
  ucfirst,
};
